export default __webpack_public_path__ + "static/media/card-cover-1.e42015fc.jpg";